<template>
  <el-form class="location-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="defaultVal">
      <template slot="label">
        默认值
      </template>
      <location-val-selector
        :canUseVars="canUseVars"
        :setting="control.defaultVal"
      ></location-val-selector>
    </el-form-item>
    <el-form-item prop="range">
      <template slot="label">
        定位范围
      </template>
      <el-radio-group
        :value="Boolean(control.range)"
        @input="$set(control, 'range', $event ? {} : null)"
      >
        <el-radio :label="false">不限</el-radio>
        <el-radio :label="true">限制</el-radio>
      </el-radio-group>
      <template v-if="control.range">
        <location-val-selector
          :canUseVars="canUseVars"
          :setting="control.range"
        ></location-val-selector>
        <el-input
          v-model="control.range.radius"
          type="number"
          placeholder="请输入半径（米）"
        ></el-input>
      </template>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import LocationValSelector from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/LocationValSelector.vue"
import { decorateSheet, getCanUseType } from "@/utils/sheet"

export default {
  name: "location-control",
  components: {
    LocationValSelector
  },
  props: {
    control: Object,
    sheet: Object,
    availableSheetMap: Object
  },
  computed: {
    canUseVars() {
      let canUseType = getCanUseType(this.control._type)
      let varGroup = [this.getVars(this.sheet, canUseType)]
      decorateSheet(this.sheet)
        .controls.filter(control => control._type === "ref" && control.oneFlag && control._cid)
        .forEach(refControl => {
          if (this.availableSheetMap[refControl.refSheetId])
            varGroup.push(
              this.getVars(this.availableSheetMap[refControl.refSheetId], canUseType, refControl)
            )
        })
      return varGroup.filter(i => i.options.length != 0)
    }
  },
  methods: {
    getVars(sheetDef, canUseType, refControl) {
      let vars = [],
        title = ""
      if (!refControl) title = "自己"
      else title = refControl.name
      decorateSheet(sheetDef).controls.forEach(control => {
        // 跳过自身和新建的字段
        if (control._cid === this.control._cid || !control._cid) return
        if (canUseType.includes(control._type)) {
          let v = control._cid
          let name = control.name
          if (refControl) v = refControl._cid + "_" + v
          vars.push({
            label: `[${title}] ${name}`,
            type: control._type,
            value: "v" + v
          })
        }
      })
      return { title, label: title, options: vars }
    }
  }
}
</script>

<style lang="scss" scoped></style>
